/* ==========================================================================
   Atmos — section behaviour
   Every initialiser is idempotent (elements are marked once bound) and scoped
   to the element it is given, so sections can be added, removed or reloaded
   independently — including by the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* Marks an element so a second init pass skips it. */
  function claim(el, key) {
    var flag = 'ah' + key;
    if (el.dataset[flag] === 'true') return false;
    el.dataset[flag] = 'true';
    return true;
  }

  /* ---------------------------------------------------------------- Announce */
  function initAnnouncement(scope) {
    $$('[data-ah-announce]', scope).forEach(function (bar) {
      if (!claim(bar, 'Announce')) return;

      var slides = $$('[data-ah-announce-slide]', bar);
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var speed = parseInt(bar.dataset.speed, 10) || 5000;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }

      function start() {
        if (reduceMotion || bar.dataset.autoplay === 'false') return;
        stop();
        timer = window.setInterval(function () { show(index + 1); }, speed);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      var prev = $('[data-ah-announce-prev]', bar);
      var next = $('[data-ah-announce-next]', bar);
      if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);

      show(0);
      start();
    });
  }

  /* -------------------------------------------------------------- Mega menu */
  function initMegaMenu(scope) {
    $$('[data-ah-nav]', scope).forEach(function (nav) {
      if (!claim(nav, 'Mega')) return;

      var header = nav.closest('[data-ah-header]') || document;
      var items = $$('[data-ah-nav-item]', nav);
      var closeTimer = null;

      function closeAll() {
        items.forEach(function (item) {
          item.classList.remove('is-open');
          var trigger = $('[data-ah-nav-trigger]', item);
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          var panel = $('[data-ah-mega-panel="' + item.getAttribute('data-ah-nav-item') + '"]', header);
          if (panel) panel.classList.remove('is-open');
        });
      }

      function open(item) {
        var panel = $('[data-ah-mega-panel="' + item.getAttribute('data-ah-nav-item') + '"]', header);
        if (!panel) return;
        closeAll();
        item.classList.add('is-open');
        var trigger = $('[data-ah-nav-trigger]', item);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }

      function cancelClose() {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      function scheduleClose() {
        cancelClose();
        closeTimer = window.setTimeout(closeAll, 160);
      }

      items.forEach(function (item) {
        var panel = $('[data-ah-mega-panel="' + item.getAttribute('data-ah-nav-item') + '"]', header);
        var trigger = $('[data-ah-nav-trigger]', item);

        item.addEventListener('mouseenter', function () {
          cancelClose();
          if (panel) open(item);
        });
        item.addEventListener('mouseleave', scheduleClose);

        if (panel) {
          panel.addEventListener('mouseenter', cancelClose);
          panel.addEventListener('mouseleave', scheduleClose);
        }

        if (trigger && panel) {
          trigger.addEventListener('click', function (event) {
            event.preventDefault();
            if (item.classList.contains('is-open')) closeAll(); else open(item);
          });
          trigger.addEventListener('focus', function () {
            cancelClose();
            open(item);
          });
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll();
      });
    });
  }

  /* ------------------------------------------------------------ Mobile menu */
  function initMobileMenu(scope) {
    $$('[data-ah-menu-open]', scope).forEach(function (openBtn) {
      if (!claim(openBtn, 'MenuBtn')) return;

      var panel = document.getElementById(openBtn.getAttribute('aria-controls'));
      if (!panel) return;

      var closeBtn = $('[data-ah-menu-close]', panel);

      function setOpen(state) {
        panel.classList.toggle('is-open', state);
        openBtn.setAttribute('aria-expanded', state ? 'true' : 'false');
        document.documentElement.classList.toggle('ah-no-scroll', state);
        document.body.classList.toggle('ah-no-scroll', state);
        if (state && closeBtn) closeBtn.focus();
        if (!state) openBtn.focus();
      }

      openBtn.addEventListener('click', function () { setOpen(true); });
      if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
      });
    });
  }

  /* -------------------------------------------------------------- Accordions */
  function initAccordions(scope) {
    $$('[data-ah-accordion]', scope).forEach(function (acc) {
      if (!claim(acc, 'Accordion')) return;

      var trigger = $('[data-ah-accordion-trigger]', acc);
      var body = $('[data-ah-accordion-panel]', acc);
      if (!trigger || !body) return;

      function setState(open) {
        acc.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.height = open ? body.scrollHeight + 'px' : '0px';
      }

      trigger.addEventListener('click', function () {
        setState(!acc.classList.contains('is-open'));
      });

      setState(acc.hasAttribute('data-ah-accordion-open'));

      window.addEventListener('resize', function () {
        if (acc.classList.contains('is-open')) body.style.height = body.scrollHeight + 'px';
      });
    });
  }

  /* --------------------------------------------------------------- Carousels */
  function bindRail(rail) {
    var prev = $('[data-ah-rail-prev]', rail);
    var next = $('[data-ah-rail-next]', rail);

    function activeTrack() {
      var panel = $('[data-ah-panel].is-active', rail);
      return (panel && $('[data-ah-rail-track]', panel)) || $('[data-ah-rail-track]', rail);
    }

    function step(track) {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var track = activeTrack();
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function scrollBy(direction) {
      var track = activeTrack();
      if (!track) return;
      track.scrollBy({ left: direction * step(track), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    $$('[data-ah-rail-track]', rail).forEach(function (track) {
      track.addEventListener('scroll', sync, { passive: true });

      var down = false;
      var startX = 0;
      var startLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') return;
        down = true;
        startX = event.clientX;
        startLeft = track.scrollLeft;
        track.style.scrollSnapType = 'none';
      });

      track.addEventListener('pointermove', function (event) {
        if (!down) return;
        track.scrollLeft = startLeft - (event.clientX - startX);
      });

      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (name) {
        track.addEventListener(name, function () {
          if (!down) return;
          down = false;
          track.style.scrollSnapType = '';
        });
      });
    });

    window.addEventListener('resize', sync);
    sync();

    return { sync: sync };
  }

  function initRails(scope) {
    return $$('[data-ah-rail]', scope)
      .filter(function (rail) { return claim(rail, 'Rail'); })
      .map(bindRail);
  }

  /* ------------------------------------------------------------ Product tabs */
  function initTabs(scope, rails) {
    $$('[data-ah-tabs]', scope).forEach(function (group) {
      if (!claim(group, 'Tabs')) return;

      var tabs = $$('[data-ah-tab]', group);
      var panels = $$('[data-ah-panel]', group);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-ah-tab');

          tabs.forEach(function (other) {
            var isActive = other === tab;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var isActive = panel.getAttribute('data-ah-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });

          rails.forEach(function (rail) { rail.sync(); });
        });
      });
    });
  }

  /* ------------------------------------------------------------------- Press */
  function initPress(scope) {
    $$('[data-ah-press]', scope).forEach(function (press) {
      if (!claim(press, 'Press')) return;

      var quotes = $$('[data-ah-press-quote]', press);
      var logos = $$('[data-ah-press-logo]', press);
      if (!quotes.length) return;

      var index = 0;
      var timer = null;
      var speed = parseInt(press.dataset.speed, 10) || 4500;

      function show(next) {
        index = (next + quotes.length) % quotes.length;
        quotes.forEach(function (quote, i) {
          quote.classList.toggle('is-active', i === index);
          quote.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        logos.forEach(function (logo, i) {
          logo.classList.toggle('is-active', i === index);
        });
      }

      function start() {
        if (reduceMotion || press.dataset.autoplay === 'false') return;
        stop();
        timer = window.setInterval(function () { show(index + 1); }, speed);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      logos.forEach(function (logo, i) {
        logo.addEventListener('click', function () { show(i); start(); });
      });

      press.addEventListener('mouseenter', stop);
      press.addEventListener('mouseleave', start);

      show(0);
      start();
    });
  }

  /* -------------------------------------------------------- Hero media toggle */
  function initHeroToggle(scope) {
    $$('[data-ah-hero-toggle]', scope).forEach(function (toggle) {
      if (!claim(toggle, 'HeroToggle')) return;

      toggle.addEventListener('click', function () {
        var paused = toggle.classList.toggle('is-paused');
        toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);

        var media = $('video', toggle.closest('.ah-hero') || document);
        if (media) {
          if (paused) media.pause(); else media.play();
        }
      });
    });
  }

  /* ---------------------------------------------------------------- Marquee */
  function initMarquee(scope) {
    $$('[data-ah-marquee]', scope).forEach(function (track) {
      if (!claim(track, 'Marquee')) return;

      // Duplicate the run once so the translate(-50%) loop is seamless.
      Array.prototype.slice.call(track.children).forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* ------------------------------------------------------- Newsletter slide */
  function initNewsletterSlide(scope) {
    $$('[data-ah-slide]', scope).forEach(function (slide) {
      if (!claim(slide, 'Slide')) return;

      var close = $('[data-ah-slide-close]', slide);
      var form = $('form', slide);
      var delay = parseInt(slide.dataset.delay, 10) || 12000;
      var storageKey = 'ah-newsletter-dismissed';
      var dismissed = false;

      try {
        dismissed = window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        dismissed = false;
      }

      function remember() {
        try {
          window.localStorage.setItem(storageKey, '1');
        } catch (error) {
          /* storage unavailable — this session only */
        }
      }

      function open() {
        if (dismissed) return;
        slide.classList.add('is-open');
        window.removeEventListener('scroll', onScroll);
      }

      function onScroll() {
        var seen = window.scrollY + window.innerHeight;
        if (seen > document.documentElement.scrollHeight * 0.45) open();
      }

      if (!dismissed) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.setTimeout(open, delay);
      }

      if (close) {
        close.addEventListener('click', function () {
          slide.classList.remove('is-open');
          dismissed = true;
          remember();
        });
      }

      var flag = $('[data-ah-flag]');
      if (flag) {
        flag.addEventListener('click', function () {
          dismissed = false;
          slide.classList.add('is-open');
        });
      }

      if (form) {
        // The form posts to Shopify; just stop re-prompting this visitor.
        form.addEventListener('submit', remember);
      }
    });
  }

  /* ------------------------------------------------------------- Quantity */
  function initQuantity(scope) {
    $$('[data-ah-qty]', scope).forEach(function (widget) {
      if (!claim(widget, 'Qty')) return;

      var input = $('input', widget);
      if (!input) return;

      function nudge(delta) {
        var min = parseInt(input.min, 10) || 1;
        var next = (parseInt(input.value, 10) || min) + delta;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var down = $('[data-ah-qty-down]', widget);
      var up = $('[data-ah-qty-up]', widget);
      if (down) down.addEventListener('click', function () { nudge(-1); });
      if (up) up.addEventListener('click', function () { nudge(1); });
    });
  }

  /* ------------------------------------------------------- Variant picking */
  function initVariants(scope) {
    // The product form is rendered by Shopify's {% form %} tag, which carries the id rather than the data attribute
    $$('[data-ah-product-form], #ah-product-form', scope).forEach(function (form) {
      if (!claim(form, 'Variants')) return;

      var dataEl = $('[data-ah-variants]', form);
      var idInput = form.querySelector('input[name="id"]');
      if (!dataEl || !idInput) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      var groups = $$('[data-ah-option-index]', form);
      var priceEl = $('[data-ah-price]', form.closest('.ah-pdp__buy') || document);
      var submit = $('[data-ah-submit]', form);

      function selection() {
        return groups.map(function (group) {
          var active = $('.ah-pdp__pill.is-active', group);
          return active ? active.getAttribute('data-ah-option-value') : null;
        });
      }

      function money(cents) {
        // Mirrors the shop's format loosely; the server value wins on reload.
        return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function apply() {
        var chosen = selection();
        var match = variants.find(function (variant) {
          return chosen.every(function (value, i) {
            return value === null || variant.options[i] === value;
          });
        });
        if (!match) return;

        idInput.value = match.id;

        if (priceEl) {
          var currency = (priceEl.textContent.match(/[^\d\s.,]+/) || ['$'])[0];
          var html = '<span>' + currency + money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<span class="ah-pdp__price--was">' + currency + money(match.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = html;
        }

        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? submit.dataset.addLabel
            : submit.dataset.soldOutLabel;
        }
      }

      groups.forEach(function (group) {
        $$('.ah-pdp__pill', group).forEach(function (pill) {
          pill.addEventListener('click', function () {
            $$('.ah-pdp__pill', group).forEach(function (other) {
              other.classList.toggle('is-active', other === pill);
            });

            var label = $('.ah-pdp__option-value', group);
            if (label) label.textContent = pill.getAttribute('data-ah-option-value');

            apply();
          });
        });
      });
    });
  }

  /* --------------------------------------------------------------- Hotspots */
  function initHotspots(scope) {
    $$('[data-ah-hotspots]', scope).forEach(function (section) {
      if (!claim(section, 'Hotspots')) return;

      var triggers = $$('[data-ah-hotspot]', section);
      var slides = $$('[data-ah-hotspot-slide]', section);
      if (!triggers.length || !slides.length) return;

      function show(index) {
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-ah-hotspot-slide') === String(index);
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        triggers.forEach(function (trigger) {
          trigger.classList.toggle('is-active', trigger.getAttribute('data-ah-hotspot') === String(index));
        });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          show(parseInt(trigger.getAttribute('data-ah-hotspot'), 10));
        });
      });

      show(0);
    });
  }

  /* --------------------------------------------------------- Search overlay */
  function initSearchOverlay(scope) {
    $$('[data-ah-search-open]', scope).forEach(function (trigger) {
      if (!claim(trigger, 'SearchOpen')) return;

      var overlay = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!overlay) return;

      var input = $('[data-ah-search-input]', overlay);
      var results = $('[data-ah-search-results]', overlay);
      var suggestions = $('[data-ah-search-suggestions]', overlay);
      var closeBtn = $('[data-ah-search-close]', overlay);
      var timer = null;
      var lastQuery = '';

      function setOpen(state) {
        overlay.classList.toggle('is-open', state);
        trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
        document.documentElement.classList.toggle('ah-no-scroll', state);
        document.body.classList.toggle('ah-no-scroll', state);
        if (state && input) {
          // Wait for the panel to be visible before focusing.
          window.setTimeout(function () { input.focus(); }, 60);
        } else {
          trigger.focus();
        }
      }

      function clearResults() {
        if (results) { results.hidden = true; results.textContent = ''; }
        if (suggestions) suggestions.hidden = false;
      }

      function render(products, query) {
        if (!results) return;
        results.textContent = '';

        if (!products.length) {
          var empty = document.createElement('p');
          empty.className = 'ah-search-overlay__empty';
          empty.textContent = (results.dataset.emptyText || 'No product matches') + ' \u201c' + query + '\u201d';
          results.appendChild(empty);
        } else {
          products.forEach(function (product) {
            var row = document.createElement('a');
            row.className = 'ah-search-result';
            row.href = product.url;

            var media = document.createElement('span');
            media.className = 'ah-search-result__media';
            if (product.featured_image && product.featured_image.url) {
              var img = document.createElement('img');
              img.src = product.featured_image.url;
              img.alt = '';
              img.loading = 'lazy';
              media.appendChild(img);
            }
            row.appendChild(media);

            var title = document.createElement('span');
            title.className = 'ah-search-result__title';
            title.textContent = product.title;
            row.appendChild(title);

            if (product.price) {
              var price = document.createElement('span');
              price.className = 'ah-search-result__price';
              price.textContent = product.price;
              row.appendChild(price);
            }

            results.appendChild(row);
          });
        }

        results.hidden = false;
        if (suggestions) suggestions.hidden = true;
      }

      function lookUp(query) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

        fetch(url)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || query !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, query);
          })
          .catch(function () { /* leave the suggestions in place */ });
      }

      trigger.addEventListener('click', function () { setOpen(true); });
      if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) setOpen(false);
      });

      if (input) {
        input.addEventListener('input', function () {
          var query = input.value.trim();
          lastQuery = query;
          if (timer) window.clearTimeout(timer);

          if (query.length < 2) { clearResults(); return; }
          timer = window.setTimeout(function () { lookUp(query); }, 250);
        });
      }
    });
  }

  /* ------------------------------------------------------------ Localization */
  function initLocaleSelects(scope) {
    $$('[data-ah-locale-select]', scope).forEach(function (select) {
      if (!claim(select, 'Locale')) return;

      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  /* ----------------------------------------------------------------- Reveal */
  function initReveal(scope) {
    var targets = $$('.ah-reveal', scope).filter(function (el) { return claim(el, 'Reveal'); });
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (target) { target.classList.add('is-visible'); });
      return;
    }

    // Only hide content once an observer is genuinely watching it.
    document.documentElement.classList.add('ah-js');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Reveal on intersection, and also for anything already scrolled past
        // so a deep link or a fast jump never leaves content stuck at opacity 0.
        var passed = entry.boundingClientRect.bottom < 0;
        if (!entry.isIntersecting && !passed) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (target) { observer.observe(target); });
  }

  /* ----------------------------------------------------- Contact form guard */
  // Two cheap layers on top of Shopify's hCaptcha: a honeypot, and a minimum
  // time on the form. Both run in the browser, so they only stop bots that
  // render the page — hCaptcha stays the server-side check.
  //
  // This listens in the capture phase on document, not on the form. Shopify's
  // hCaptcha script binds its own submit listener to the form, cancels the
  // event, fetches a token and then submits natively; a listener on the form
  // would run too late to stop that. Capture on an ancestor runs first, so
  // stopping the event here means Shopify's handler never sees it.
  var contactGuardOpenedAt = new WeakMap();

  function initContactGuard(scope) {
    $$('[data-ah-contact-guard]', scope).forEach(function (form) {
      // Not 'ContactGuard': claim() writes its flag to dataset.ah<Key>, which for
      // that key is the very data-ah-contact-guard attribute the markup already
      // sets, so the form would read as claimed before init ever ran.
      if (!claim(form, 'ContactGuardInit')) return;
      contactGuardOpenedAt.set(form, Date.now());
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-ah-contact-guard]')) return;

    var honeypot = form.querySelector('[data-ah-hp]');
    var minMs = (parseFloat(form.getAttribute('data-ah-min-seconds')) || 0) * 1000;
    var openedAt = contactGuardOpenedAt.get(form) || 0;

    // A filled honeypot is a bot, or an over-eager autofill. Either way the
    // message is the same, so a false positive is never silent.
    var tooFast = minMs && openedAt && Date.now() - openedAt < minMs;
    var trapped = honeypot && honeypot.value.trim() !== '';
    var notice = form.querySelector('[data-ah-guard-notice]');

    if (!tooFast && !trapped) {
      if (notice) notice.hidden = true;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (!notice) return;
    notice.textContent = form.getAttribute('data-ah-guard-error') ||
      'Please take a moment before sending, then try again.';
    notice.hidden = false;
  }, true);

  /* ---------------------------------------------------------- Sticky header */
  // The CSS pins the wrapper via :has(); mirror it as a plain class so browsers
  // without :has() support still get a sticky header.
  function initStickyHeader(scope) {
    $$('.ah[data-ah-sticky]', scope).forEach(function (el) {
      var host = el.closest('.shopify-section');
      if (host) host.classList.add('ah-sticky-host');
    });
  }

  /* -------------------------------------------------------------- Bootstrap */
  function init(scope) {
    var root = scope || document;
    initStickyHeader(root);
    initContactGuard(root);
    initAnnouncement(root);
    initMegaMenu(root);
    initMobileMenu(root);
    initAccordions(root);
    initTabs(root, initRails(root));
    initPress(root);
    initHeroToggle(root);
    initMarquee(root);
    initNewsletterSlide(root);
    initQuantity(root);
    initVariants(root);
    initHotspots(root);
    initSearchOverlay(root);
    initLocaleSelects(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind whichever section was just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
